export const onlyNumbersMask = (value?: string) => {
  if (value) {
    return value.replace(/\D/g, '')
  }
  return ''
}
